import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectosComponent {
  filtro = {}

  constructor (ViaticosCatalgosProyectosService, $filter) {
    this.ViaticosCatalgosProyectosService = ViaticosCatalgosProyectosService
    this.filterBy = $filter('filter')
  }

  $onInit () {
    this.promise = this.ViaticosCatalgosProyectosService.get()
      .then(({data}) => {
        this.data = data
        this.filtrar()
      })
  }

  filtrar () {
    this.resultados = this.filtro.general ? this.filterBy(this.data, this.filtro.general) : this.data
    this.resultadosOcultos = this.data.length - this.resultados.length
  }
}

module.component('viaticosConfiguracionProyectos', {
  template,
  controller: ViaticosConfiguracionProyectosComponent,
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyectos/component.js